export const UserRole = {
    SUPERADMIN: 1,
    CAJERO: 2,
    ADMIN: 3,
    ADMINALIADO: 4
};